import React, { useState } from 'react'
import { useApp } from '../../context/AppContext'
import { Phone, ArrowRight, Loader2 } from 'lucide-react'

function PhoneAuth({ onPhoneSubmit }) {
  const [phoneNumber, setPhoneNumber] = useState('')
  const [isValid, setIsValid] = useState(false)
  const { sendOTP, isLoading } = useApp()

  const validatePhoneNumber = (phone) => {
    // Indian mobile: exactly 10 digits, or with +91/91 prefix
    const digits = phone.replace(/\D/g, '')
    if (digits.length === 10) return true
    if (digits.startsWith('91') && digits.length === 12) return true
    return false
  }

  const handlePhoneChange = (e) => {
    const value = e.target.value
    setPhoneNumber(value)
    setIsValid(validatePhoneNumber(value))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!isValid) return

    try {
      await sendOTP(phoneNumber)
      // Call the parent component callback to proceed to OTP step
      if (onPhoneSubmit) {
        onPhoneSubmit(phoneNumber)
      }
    } catch (error) {
      console.error('Failed to send OTP:', error)
    }
  }

  return (
    <div className="flex justify-center">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 max-w-md w-full p-6">
        <div className="text-center mb-6">
          <div className="w-12 h-12 bg-primary-600 text-white rounded-full flex items-center justify-center mx-auto mb-4">
            <Phone className="w-6 h-6" />
          </div>
          <h2 className="text-xl font-bold text-gray-900 mb-2">
            Enter Your Phone Number
          </h2>
          <p className="text-gray-600 text-sm">
            We'll send you a verification code to get started
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
              Phone Number
            </label>
            <div className="relative">
              <input
                type="tel"
                id="phone"
                value={phoneNumber}
                onChange={handlePhoneChange}
                placeholder="9228138042"
                className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200 ${isValid ? 'border-green-500' : phoneNumber ? 'border-red-500' : ''}`}
                required
              />
              {isValid && (
                <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                  <div className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center">
                    <span className="text-white text-xs">✓</span>
                  </div>
                </div>
              )}
            </div>
            {phoneNumber && !isValid && (
              <p className="text-red-500 text-sm mt-1">
                Please enter a valid 10-digit Indian mobile number
              </p>
            )}
          </div>

          <button
            type="submit"
            disabled={!isValid || isLoading}
            className={`w-full flex items-center justify-center py-3 px-4 rounded-lg font-semibold transition-colors ${
              isValid && !isLoading
                ? 'bg-primary-600 hover:bg-primary-700 text-white'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            {isLoading ? (
              <>
                <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                Sending OTP...
              </>
            ) : (
              <>
                Send Verification Code
                <ArrowRight className="w-5 h-5 ml-2" />
              </>
            )}
          </button>
        </form>

        
      </div>
    </div>
  )
}

export default PhoneAuth
